import {Icon} from '@wandb/weave/components/Icon';
import {Browse3} from '@wandb/weave/components/PagePanelComponents/Home/Browse3';
import React, {useCallback, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';

import {WEAVE_SLUG, WEAVE_TITLE} from '../routes/paths';
import {apolloEndpoint} from '../util/apollo';
import {trackPageViewed} from '../util/navigation';
import {useBetaFeatureWeave1} from '../util/useBetaFeature';
import {BannerBoldText, BannerFlexWrapper, BannerTextWrapper} from './Banner';
import {WeaveIntercomChatButton} from './IntercomChatButton';

type ProjectWeaveTabProps = {
  entityName: string;
  projectName: string;
};

export const ProjectWeaveTab = (props: ProjectWeaveTabProps) => {
  // for page view tracking
  useEffect(() => {
    trackPageViewed(WEAVE_TITLE);
  }, []);

  const weave1Enabled = useBetaFeatureWeave1();
  const history = useHistory();
  const projectOverviewPath = `/${props.entityName}/${props.projectName}/overview`;
  const navigateAwayFromProject = useCallback(() => {
    history.push(projectOverviewPath);
  }, [history, projectOverviewPath]);

  if (!weave1Enabled) {
    return (
      <div
        className={WEAVE_SLUG}
        style={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          backgroundColor: 'white',
        }}>
        <div style={{padding: '20px'}}>
          <BannerFlexWrapper>
            <Icon name="lightbulb-info" />
            <BannerTextWrapper>
              <BannerBoldText>Weave</BannerBoldText>allows you to track,
              analyze, and compare ML functions such as LLM invocations,
              document retrievals, and model predictions. Weave needs weave1
              enabled to work.{' '}
              <Link to={'/settings#betafeatures'}>Click here</Link> to go to
              your user settings.
            </BannerTextWrapper>
          </BannerFlexWrapper>
        </div>
      </div>
    );
  }

  return (
    <div
      className={WEAVE_SLUG}
      style={{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'white',
      }}>
      <Browse3
        hideHeader
        headerOffset={60}
        projectRoot={(entityName: string, projectName: string) => {
          return `/${entityName}/${projectName}/${WEAVE_SLUG}`;
        }}
        navigateAwayFromProject={navigateAwayFromProject}
        gorillaApolloEndpoint={apolloEndpoint}
      />
      <WeaveIntercomChatButton />
    </div>
  );
};
